export default () => ({
    name: "",
    country: "",
});
  